import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Cookies from 'js-cookie';

const axios = require('axios');

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const SimpleDropDown = ({ userParams }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  let [accessLevel, setAccessLevel] = useState(userParams.userType);
  const handleChange = (event) => {
    // setAccessLevel(event.target.value);
    // console.log(event.target.value);
    setAccessLevel(event.target.value);
    Cookies.set(
      'accessLvl',
      JSON.stringify({
        accessLvl: event.target.value,
        userid: userParams['id'],
      })
      // 2
    );

    window.location.reload();

    let newUserParams = userParams;
    newUserParams['userType'] = event.target.value;
    newUserParams['userid'] = newUserParams['id'];
    newUserParams['password'] = '';
    let apiKeys = {
      admin: 'jnjirej9reinvuiriuerhuinui',
      serviceUser: 'juit959fjji44jcion4moij0kc',
    };

    let userType = 'admin';
    let token =
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImJlcm5hcmQiLCJwYXNzd29yZCI6ImFzZGZhc2RmIiwiaWF0IjoxNjI1NDc1MzI0fQ.cN5Z6hzQtecKqtwSOlptLM-cqrFQwEJJZfgL_58Df3c';

    let config = {
      headers: { Authorization: `Bearer ${token}`, apikey: apiKeys[userType] },
    };

    axios
      .post(`${process.env.REACT_APP_API}/edituser`, newUserParams, config)
      .then((result) => {
        console.log(result);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <Select
        style={{ minWidth: 120 }}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        value={accessLevel}
        onChange={handleChange}>
        <MenuItem value={'user'}>user</MenuItem>
        <MenuItem value={'serviceUser'}>serviceUser</MenuItem>
        <MenuItem value={'admin'}>admin</MenuItem>
      </Select>
    </div>
  );
};

export default SimpleDropDown;
